import { useEffect, useMemo, useRef, useState } from "react"

import { ColorPickerInputGroup } from "twyne-new.ui"

import { TailwindSandboxPure } from "@/modules/cms/views/post/components/builder/Content/TailwindSandbox"

import { parseColor } from "../../utils"

import { useGetColorFromDocument } from "./helpers"

const ColorPreview = ({ value, ...props }) => {
  const [overrideColor, setOverrideColor] = useState()
  const colorRendered = useMemo(() => !value || typeof value !== 'string' ? value : overrideColor, [overrideColor, value])

  return <>
    <Sandbox value={value} onChangeColor={setOverrideColor} key={value} />
    <ColorPickerInputGroup {...props} value={colorRendered} />
  </>
}

const Sandbox = ({ value, onChangeColor }) => <>
  <div className="hidden">
    <TailwindSandboxPure>
      <ColorRendered value={value} onChangeColor={onChangeColor} />
    </TailwindSandboxPure>
  </div>
</>

const ColorRendered = ({ value, onChangeColor }) => {
  const colorRef = useRef()
  const color = useGetColorFromDocument({ colorRef, value })
  const background = useMemo(() => parseColor(value, 'bg'), [value])

  useEffect(() => {
    if (color) {
      onChangeColor(color)
    }
  }, [color, onChangeColor])

  return <div className={background} ref={colorRef} />
}

export default ColorPreview
